<template>
  <!-- modal -->
  <div class="dimed">
    <div class="layer">
      <!-- header -->
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Emoney.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.Emoney.msg2') }}</div>
      </div>
      <!-- //header -->

      <!-- body -->
      <div class="layer__body">
        <div class="menu__event">
          <!-- one item -->
          <!-- 체크되면 아래 요소에 on 클래스 추가, span.ico-checked 요소 추가 -->
          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY200') >= 0" @mouseup="onEmoneyPay('PAY200')">
            <div>
              <img src="@/assets/images/user/logo-ic.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.Emoney.msg3') }}</span>
            </div>
          </div>
          <!-- //one item -->

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY205') >= 0" @mouseup="onEmoneyPay('PAY205')">
            <div>
              <img src="@/assets/images/user/logo-waon.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">WAON</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY202') >= 0" @mouseup="onEmoneyPay('PAY202')">
            <div>
              <img src="@/assets/images/user/logo-nanaco.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">nanaco</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY204') >= 0" @mouseup="onEmoneyPay('PAY204')">
            <div>
              <img src="@/assets/images/user/logo-edy.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.Emoney.msg4') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY203') >= 0" @mouseup="onEmoneyPay('PAY203')">
            <div>
              <img src="@/assets/images/user/logo-quic-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">QUICPay</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY201') >= 0" @mouseup="onEmoneyPay('PAY201')">
            <div>
              <img src="@/assets/images/user/logo-i-d.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">iD</span>
            </div>
          </div>
        </div>
      </div>
      <!-- //body -->
      <div class="layer__button">
        <button @mouseup="closeEmoney()" class="btn btn--line btn--xlg btn-anim">{{ $t('Modal.Emoney.msg5') }}</button>
      </div>
    </div>
    <!-- //modal -->
    <EmoneyPay @setPayComplete="setPayComplete" @closeEmoneyPay="emoneyPayYn = false" v-if="emoneyPayYn == true" :totalUprc="totalUprc" />
  </div>
</template>
<script>
import emoneyPay from '@/components/modal/payment/EmoneyPay.vue';
import axios from 'axios';

export default {
  name: 'emoney',
  data() {
    return {
      emoneyPayYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
      //결제 방법 종류
      supportPayments: this.$store.getters.getPosConfig.posConfig.supportPayments,
    };
  },
  mounted() {},
  props: {
    totalUprc: Number,
    tran: Object,
  },
  methods: {
    setPayComplete(tranObj) {
      this.emoneyPayYn = false;
      this.$emit('setPayComplete', tranObj);
    },
    onEmoneyPay(paymethod) {
      this.tran.PAYMENTLIST[0].SETTLE_METHOD = paymethod;
      if (this.oneCallFn()) return;
      this.$logInfo(`Select Emoney Method : ${paymethod}`);
      let url = '/api/payment/payment';

      axios
        .post(url, this.tran)
        .then((response) => {
          if (response.data.status == 0) {
            this.emoneyPayYn = true;
            this.$logInfo(`Payment Success`);
          } else {
            this.$logInfo(`Payment Fail status : ${response.data.status} message : ${response.data.message}`);
            this.$emit('paymentError');
          }
        })
        .catch((error) => {
          this.$logInfo(`Payment axios Error : ${error}`);
          this.closeEmoney();
          this.$emit('paymentError');
        })
        .finally(() => {
          this.closeEmoney();
          this.resetDone();
        });
    },
    closeEmoney() {
      this.$logInfo(`Emoney Close Payment`);
      this.$store.dispatch('startIdle');
      this.$emit('closeEmoney');
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  components: {
    EmoneyPay: emoneyPay,
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped></style>
